import { useEffect, useState } from 'react'
import Page from '../layout/Page'
import { Box, Grid2 as Grid, Typography } from '@mui/material'
import RoleContext from '../auth/RoleContext'
import { getAuthenticator } from '../auth/auth'
import { useRole } from "../auth/role"

export default function HomePage(props = {}) {
  const { hasAnyRole } = useRole()
  const [showNotAuthorizedMessage, setShowNotAuthorizedMessage] = useState(false)

  const [account] = useState(getAuthenticator().getCurrentAccount())

  useEffect(() => {
    setShowNotAuthorizedMessage(!hasAnyRole())
  })

  return (
    <RoleContext.Consumer>
      {roleCtx => (
        <Page {...props}>
          <Box sx={{padding: '1em'}}>
            <Grid container spacing={1}>
              <Grid item size={12}><Typography variant="h4" gutterBottom>SRA Portal Home</Typography></Grid>
              <Grid item size={12}><span>Name: {account?.name || 'null'}</span></Grid>
              <Grid item size={12}><span>Username: {account?.username || 'null'}</span></Grid>
              <Grid item size={12}><span>Email: {account?.idTokenClaims.mail || 'null'}</span></Grid>
              <Grid item size={12}><span>Department: {account?.idTokenClaims.department || 'N/A'}</span></Grid>
              <Grid item size={12}><span>SRA Portal Role: {roleCtx.role?.name || 'No roles'}</span></Grid>
              {showNotAuthorizedMessage && <Grid item size={12}>
                <Typography variant="h6" color="error">
                  <br />
                  <span>You don't have any roles assigned for this site.</span>
                  <br />
                  <span>Please contact your Coca-Cola sponsor to request the correct level of access.</span>
                </Typography>
              </Grid>}
            </Grid>
          </Box>
        </Page>
      )
      }
    </RoleContext.Consumer>
  )
}